import {FETCH_STATUS} from '../fetch-status.model';

interface Props {
  fetchState: number;
  articleUsageState: number;
}

export function FetchArticleUsageStateLabel(props: Props) {
  if (props.fetchState === FETCH_STATUS.NEW) {
    return null;
  }

  switch (props.articleUsageState) {
    case 0:
      return <span className="label label-warning"
                   title="dies ist der erste Abruf für diesen Artikel">
        Neu
      </span>;
    case 1:
      return <span className="label label-default"
                   title="der Artikel wurde bereits in einem früheren Abruf bearbeitet">
        Bestand
      </span>;
    default:
      return null;
  }
}
